import styled from 'styled-components'
import colors from 'constants/colors'

export const MessageBoxContainer = styled.div`
  position: absolute;
  top: 0px;
  right: 91px;
  box-sizing: border-box;
  border-collapse: collapse;
  width: 285px;  
  display: ${(props) => (props.active ? 'inline-block': 'none')};
  z-index: 1000;
`;

export const MessageItem = styled.div`
  display: flex;
  width: 100%;
  height: 81px;
  background-color: ${colors.darkBlue};
  border: solid ${colors.black2};
  border-width: 1px;
  color: ${colors.white};
  cursor: pointer;

  .contentBox {
    font-size: 12px;
    padding: 10px 5px;
    width: 238px;
    position: relative;
    
    .content {
      font-weight: 600;
      padding-left: 10px;

      .messageWriter {
        margin-right: 10px;
      }

      .roomNumber {
        color: ${colors.lightBlue};
      }
    }

    .dateTime {
      color: ${colors.grey};
      padding-left: 10px;
    }

    .message {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-left: 10px;
    }
  }
`;